import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { ICollectionInfo } from '../../../../Collections/space/ICollectionInfo';
import { IScheduleInfo } from '../../../../schedule/types/IScheduleInfo';
import { IGroupInfo } from '../../../../userManagement/groups/models/IGroupInfo';
import { renameContent } from '../../../actions/RenameContentAction';
import { ISetNameAction } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userCanEditGroup, userCanEditSchedule } from './IEntityActionHelpers';
import { isSingleNonEmbeddedDatasource} from './IEntityActionHelpers';

export const RenameEntityAction: IEntityAction<IContentInfo, ISetNameAction> = {
  name: EntityActionNames.Rename,
  translateName: Messages.rename_action,
  isVisible: () => true,
  isClickable: (availableActions: ISetNameAction, targetItems: IContentInfo[], state: AppState) =>
      targetItems.length === 1 &&
        ((availableActions && availableActions.setName)
        || userCanEditSchedule(state, targetItems)),
  createReduxAction: (targetItems: IContentInfo[]) => renameContent(targetItems[0])
};

export const RenameScheduleAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.Rename,
  translateName: Messages.rename_action,
  isVisible: () => true,
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[], state: AppState) =>
      targetItems.length === 1 && userCanEditSchedule(state, targetItems),
  createReduxAction: (targetItems: IScheduleInfo[]) => renameContent(targetItems[0] as any)
};

export const RenameGroupAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.Rename,
  translateName: Messages.rename_action,
  isVisible: () => true,
  isClickable: (_availableActions: {}, targetItems: IGroupInfo[], state: AppState) =>
      targetItems.length === 1 && userCanEditGroup(state, targetItems),
  createReduxAction: (targetItems: IGroupInfo[]) => renameContent(targetItems[0] as any)
};

export const RenameCollectionAction: IEntityAction<ICollectionInfo, {}> = {
  name: EntityActionNames.Rename,
  translateName: Messages.rename_action,
  isVisible: () => true,
  isClickable: (_availableActions: {}, targetItems: ICollectionInfo[], state: AppState) =>
      targetItems.length === 1 && CompositeSessionInfoSelectors.currentUserIsAdminOrOwnerSelector(targetItems[0].owner)(state),
  createReduxAction: (targetItems: ICollectionInfo[]) => renameContent(targetItems[0])
};

export const RenameDatasourceAction: IEntityAction<IContentInfo, ISetNameAction> = {
  name: EntityActionNames.Rename,
  translateName: Messages.rename_action,
  isVisible: (targetItems: IContentInfo[]) => isSingleNonEmbeddedDatasource(targetItems),
  isClickable: (availableActions: ISetNameAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && (availableActions && availableActions.setName) && isSingleNonEmbeddedDatasource(targetItems),
  createReduxAction: (targetItems: IContentInfo[]) => renameContent(targetItems[0])
};
